import { useContext } from "react";
import { languageContext } from "../contexts/languageContext";

export function useLanguage() {
    return useContext(languageContext);
}
